import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './en/common.json';
import enNavigation from './en/navigation.json';
import enAuth from './en/auth.json';
import enOptimizer from './en/optimizer.json';
import enFooter from './en/footer.json';
import enChat from './en/chat.json';
import enPages from './en/pages.json';
import plCommon from './pl/common.json';
import plNavigation from './pl/navigation.json';
import plAuth from './pl/auth.json';
import plOptimizer from './pl/optimizer.json';
import plFooter from './pl/footer.json';
import plChat from './pl/chat.json';
import plPages from './pl/pages.json';
import ruCommon from './ru/common.json';
import ruNavigation from './ru/navigation.json';
import ruAuth from './ru/auth.json';
import ruOptimizer from './ru/optimizer.json';
import ruFooter from './ru/footer.json';
import ruChat from './ru/chat.json';
import ruPages from './ru/pages.json';
const getSavedLanguage = (): string => {
  const saved = localStorage.getItem('language');
  if (saved && ['en', 'pl', 'ru'].includes(saved)) {
    return saved;
  }
  const browserLang = navigator.language.split('-')[0];
  return ['en', 'pl', 'ru'].includes(browserLang) ? browserLang : 'en';
};
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        navigation: enNavigation,
        auth: enAuth,
        optimizer: enOptimizer,
        footer: enFooter,
        chat: enChat,
        pages: enPages,
      },
      pl: {
        common: plCommon,
        navigation: plNavigation,
        auth: plAuth,
        optimizer: plOptimizer,
        footer: plFooter,
        chat: plChat,
        pages: plPages,
      },
      ru: {
        common: ruCommon,
        navigation: ruNavigation,
        auth: ruAuth,
        optimizer: ruOptimizer,
        footer: ruFooter,
        chat: ruChat,
        pages: ruPages,
      },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'auth', 'optimizer', 'footer', 'chat', 'pages'],
    interpolation: {
      escapeValue: false, 
    },
    react: {
      useSuspense: false,
    },
  });
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;
export default i18n;
